var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-full md:pl-10 md:w-3/4 md:pr-20" }, [
        _c(
          "form",
          { attrs: { method: "POST" } },
          [
            _c("div", { staticClass: "mb-12" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.title,
                    expression: "form.title",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.titleValidate,
                    expression: "titleValidate",
                  },
                ],
                attrs: { id: "title", name: "title", type: "text" },
                domProps: { value: _vm.form.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "title", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-1 text-sm font-sans-italic text-gray-dark" },
                [
                  _vm._v(
                    "\n            Character count: " +
                      _vm._s(_vm.characterCount) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("title"),
                      expression: "errors.has('title')",
                    },
                  ],
                  staticClass: "text-lg error text-error-red",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.errors.first("title")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("RadioGroup", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    name: "hasHostedBefore",
                    id: "hasHostedBefore",
                    options: [
                      { title: "No", value: false },
                      { title: "Yes", value: true },
                    ],
                  },
                  model: {
                    value: _vm.form.hasHostedBefore,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "hasHostedBefore", $$v)
                    },
                    expression: "form.hasHostedBefore",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("hasHostedBefore"),
                        expression: "errors.has('hasHostedBefore')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("hasHostedBefore")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "referredBy" } }, [
                _vm._v(
                  "\n            If you were referred by a Reimagine staff member, please enter their name.\n          "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.referredBy,
                    expression: "form.referredBy",
                  },
                ],
                attrs: { id: "referredBy", name: "referredBy", type: "text" },
                domProps: { value: _vm.form.referredBy },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "referredBy", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("referredBy"),
                      expression: "errors.has('referredBy')",
                    },
                  ],
                  staticClass: "text-lg error text-error-red",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.errors.first("referredBy")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _vm._m(2),
                _vm._v(" "),
                _c("RadioGroup", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    name: "openToPartnership",
                    id: "openToPartnership",
                    options: [
                      { title: "No", value: false },
                      { title: "Yes", value: true },
                    ],
                  },
                  model: {
                    value: _vm.form.openToPartnership,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "openToPartnership", $$v)
                    },
                    expression: "form.openToPartnership",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("openToPartnership"),
                        expression: "errors.has('openToPartnership')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("openToPartnership")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("h2", { staticClass: "font-sans text-n-gray-dark" }, [
                _vm._v("Event Calendar:"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "font-sans text-n-gray-dark text-32" }, [
                _vm._v(_vm._s(_vm.festivalTitle)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _vm._m(3),
                _vm._v(" "),
                _c("lab-date-picker", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "startDate",
                    name: "startDate",
                    days: _vm.days,
                    "start-at": _vm.festivalStartAt,
                    "end-at": _vm.festivalEndAt,
                  },
                  model: {
                    value: _vm.form.startDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "startDate", $$v)
                    },
                    expression: "form.startDate",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("startDate"),
                        expression: "errors.has('startDate')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("startDate")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _vm._m(4),
                _vm._v(" "),
                _c("time-picker", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|time_before:loadEndTime",
                      expression: "'required|time_before:loadEndTime'",
                    },
                  ],
                  ref: "loadStartTime",
                  attrs: { id: "loadStartTime", name: "loadStartTime" },
                  model: {
                    value: _vm.form.loadStartTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "loadStartTime", $$v)
                    },
                    expression: "form.loadStartTime",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("loadStartTime"),
                        expression: "errors.has('loadStartTime')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("loadStartTime")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-12" },
              [
                _vm._m(5),
                _vm._v(" "),
                _c("time-picker", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|time_after:loadStartTime",
                      expression: "'required|time_after:loadStartTime'",
                    },
                  ],
                  ref: "loadEndTime",
                  attrs: { id: "loadEndTime", name: "loadEndTime" },
                  model: {
                    value: _vm.form.loadEndTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "loadEndTime", $$v)
                    },
                    expression: "form.loadEndTime",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("loadEndTime"),
                        expression: "errors.has('loadEndTime')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("loadEndTime")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "group__radio" }, [
                _c("div", { staticClass: "flex flex-wrap select-box" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.private,
                            expression: "form.private",
                          },
                        ],
                        attrs: {
                          name: "private",
                          type: "radio",
                          value: "false",
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.private, "false"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "private", "false")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 radio" }),
                      _vm._v(" Public\n              "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.private,
                            expression: "form.private",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          name: "private",
                          type: "radio",
                          value: "true",
                        },
                        domProps: { checked: _vm._q(_vm.form.private, "true") },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "private", "true")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 radio" }),
                      _vm._v(" Private\n              "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("type"),
                        expression: "errors.has('type')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("private")))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "honor-of-manager",
              _vm._b(
                { ref: "honorOfManagerRef" },
                "honor-of-manager",
                {
                  isInHonorOf: _vm.form.isInHonorOf,
                  inHonorOfName: _vm.form.inHonorOfName,
                  inHonorOfPhoto: _vm.form.inHonorOfPhoto,
                  inHonorOfDescription: _vm.form.inHonorOfDescription,
                  isInHonorOfChange: (v) => (_vm.form.isInHonorOf = v),
                  inHonorOfNameChange: (v) => (_vm.form.inHonorOfName = v),
                  inHonorOfPhotoChange: (v) => (_vm.form.inHonorOfPhoto = v),
                  inHonorOfDescriptionChange: (v) =>
                    (_vm.form.inHonorOfDescription = v),
                  isValidChange: (v) => (_vm.honorOfValid = v),
                },
                false
              )
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "group__radio" }, [
                _c("div", { staticClass: "flex flex-wrap select-box" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.type,
                            expression: "form.type",
                          },
                        ],
                        attrs: {
                          name: "type",
                          type: "radio",
                          value: "digital",
                        },
                        domProps: { checked: _vm._q(_vm.form.type, "digital") },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "type", "digital")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 radio" }),
                      _vm._v(" Virtual\n              "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.type,
                            expression: "form.type",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          name: "type",
                          type: "radio",
                          value: "physical",
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.type, "physical"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "type", "physical")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 radio" }),
                      _vm._v(" In-person\n              "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("type"),
                        expression: "errors.has('type')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("type")))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "acceptDonations" } }, [
                _vm._v("Accept Donations"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "select-box" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-base font-normal",
                    attrs: { for: "acceptDonations" },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.acceptDonations,
                          expression: "form.acceptDonations",
                        },
                      ],
                      attrs: { type: "checkbox", id: "acceptDonations" },
                      domProps: {
                        checked: Array.isArray(_vm.form.acceptDonations)
                          ? _vm._i(_vm.form.acceptDonations, null) > -1
                          : _vm.form.acceptDonations,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.acceptDonations,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "acceptDonations",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "acceptDonations",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "acceptDonations", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "check inline-block mr-2" }),
                    _vm._v("Yes\n            "),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.form.type == "digital"
              ? _c("div", { key: "digital-event" }, [
                  _c("div", { staticClass: "mb-12" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.venueName,
                          expression: "form.venueName",
                        },
                      ],
                      key: "digital-venue-name",
                      attrs: {
                        id: "venueName",
                        name: "venueName",
                        type: "text",
                      },
                      domProps: { value: _vm.form.venueName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "venueName", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-12" },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c("url-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          required: true,
                          name: "venueUrl",
                          placeholder: "www.zoom.us",
                        },
                        model: {
                          value: _vm.form.venueUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "venueUrl", $$v)
                          },
                          expression: "form.venueUrl",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("venueUrl"),
                              expression: "errors.has('venueUrl')",
                            },
                          ],
                          staticClass: "text-lg error text-error-red",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("venueUrl")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-12" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.venuePassword,
                          expression: "form.venuePassword",
                        },
                      ],
                      attrs: {
                        id: "meetingPassword",
                        name: "meetingPassword",
                        type: "text",
                      },
                      domProps: { value: _vm.form.venuePassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form,
                            "venuePassword",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.form.type == "physical"
              ? _c("div", { key: "physical-event" }, [
                  _c("div", { staticClass: "mb-12" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.venueName,
                          expression: "form.venueName",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      key: "physical-venue-name",
                      attrs: {
                        id: "venueName",
                        "data-vv-validate-on": "change",
                        name: "venueName",
                        type: "text",
                      },
                      domProps: { value: _vm.form.venueName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "venueName", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("venueName"),
                            expression: "errors.has('venueName')",
                          },
                        ],
                        staticClass: "text-lg error text-error-red",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("venueName")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-12" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.venueAddress1,
                          expression: "form.venueAddress1",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      key: "physical-venue-address",
                      attrs: {
                        id: "venueAddress1",
                        "data-vv-validate-on": "change",
                        name: "venueAddress1",
                        type: "text",
                      },
                      domProps: { value: _vm.form.venueAddress1 },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form,
                            "venueAddress1",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("venueAddress1"),
                            expression: "errors.has('venueAddress1')",
                          },
                        ],
                        staticClass: "text-lg error text-error-red",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("venueAddress1")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex mb-12" }, [
                    _c("div", { staticClass: "w-1/2 mr-2" }, [
                      _c("label", { attrs: { for: "city" } }, [
                        _vm._v("\n                City\n              "),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.venueCity,
                            expression: "form.venueCity",
                          },
                        ],
                        attrs: { id: "city", name: "city", type: "text" },
                        domProps: { value: _vm.form.venueCity },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "venueCity", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-1/2 mr-2" }, [
                      _c("label", { attrs: { for: "state" } }, [
                        _vm._v("\n                State\n              "),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.venueState,
                            expression: "form.venueState",
                          },
                        ],
                        attrs: { id: "state", name: "state", type: "text" },
                        domProps: { value: _vm.form.venueState },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form,
                              "venueState",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-12" }, [
                    _c("div", { staticClass: "w-1/2 mr-2" }, [
                      _c("label", { attrs: { for: "zip" } }, [
                        _vm._v("\n                Zip\n              "),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.venueZip,
                            expression: "form.venueZip",
                          },
                        ],
                        attrs: { id: "zip", name: "zip", type: "text" },
                        domProps: { value: _vm.form.venueZip },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "venueZip", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-12" },
                    [
                      _c("label", { attrs: { for: "country" } }, [
                        _vm._v("\n              Country\n            "),
                      ]),
                      _vm._v(" "),
                      _c("countries", {
                        attrs: { id: "country" },
                        model: {
                          value: _vm.form.country,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "country", $$v)
                          },
                          expression: "form.country",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "additionalInformation" } }, [
                _vm._v("\n            Additional Instructions\n            "),
                _vm.form.type === "digital"
                  ? _c("div", { staticClass: "text-sm font-sans-book" }, [
                      _vm._v(
                        "\n              Please enter dial-in details or any other important information.\n            "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.additionalInfo,
                    expression: "form.additionalInfo",
                  },
                ],
                attrs: {
                  id: "additionalInformation",
                  name: "additionalInformation",
                  type: "text",
                },
                domProps: { value: _vm.form.additionalInfo },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "additionalInfo", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _vm._m(13),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.hostEmail,
                    expression: "form.hostEmail",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                attrs: {
                  id: "hostEmail",
                  "data-vv-validate-on": "change",
                  name: "hostEmail",
                  type: "text",
                },
                domProps: { value: _vm.form.hostEmail },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "hostEmail", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("hostEmail"),
                      expression: "errors.has('hostEmail')",
                    },
                  ],
                  staticClass: "text-lg error text-error-red",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.errors.first("hostEmail")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { attrs: { for: "hostPhone" } }, [
                _vm._v(
                  "\n            Host Phone Contact for Attendees\n          "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.hostPhone,
                    expression: "form.hostPhone",
                  },
                ],
                attrs: { id: "hostPhone", name: "hostPhone", type: "text" },
                domProps: { value: _vm.form.hostPhone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "hostPhone", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("hostPhone"),
                      expression: "errors.has('hostPhone')",
                    },
                  ],
                  staticClass: "text-lg error text-error-red",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.errors.first("hostEmail")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-6 border-top flex flex-wrap" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  class: {
                    "opacity-50 cursor-not-allowed":
                      _vm.saving || !_vm.honorOfValid,
                  },
                  attrs: { disabled: _vm.saving || !_vm.honorOfValid },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    },
                  },
                },
                [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
                2
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "mr-0 md:mr-4 mb-4 md:mb-4 w-full md:w-auto",
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  class: {
                    "opacity-50 cursor-not-allowed":
                      _vm.saving || !_vm.honorOfValid,
                  },
                  attrs: { disabled: _vm.saving || !_vm.honorOfValid },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.saveNext.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n            Save & Next\n          ")]
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-full pt-3 mt-10 border-black md:w-1/4 border-t-5 md:mt-2",
        },
        [
          _vm._m(14),
          _vm._v(" "),
          _vm.user.isAdmin
            ? _c(
                "div",
                {
                  staticClass:
                    "w-full pt-3 mt-10 border-black border-t-5 md:mt-2",
                },
                [
                  _c("h2", { staticClass: "mb-4" }, [_vm._v("Demographics")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.userOptions, function (option) {
                      return _c("li", [_vm._v(_vm._s(option.name))])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "title" } }, [
      _vm._v("\n            Event Title "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n              60 character maximum (including spaces).\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "hasHostedBefore" } }, [
      _vm._v("\n            Have you hosted a Reimagine event before? "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "openToPartnership" } }, [
      _vm._v(
        "\n            To make our events more inclusive, we often collaborate with leaders of community-based organizations and match them with Reimagine collaborators whose offerings would resonate with their communities. Are you interested in partnerships with these organizations? "
      ),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "startDate" } }, [
      _vm._v("\n            Day "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "loadStartTime" } }, [
      _vm._v("\n            Start Time "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n              Please enter all times in Pacific Daylight Time (PDT). If you are unsure of the time zone conversion, you can easily calculate it\n              "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.timeanddate.com/worldclock/converter.html?iso=20200330T180000&p1=224",
              target: "_blank",
            },
          },
          [_vm._v("\n                here\n              ")]
        ),
        _vm._v(".\n            "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "loadEndTime" } }, [
      _vm._v("\n            End Time "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "title" } }, [
      _vm._v("\n            Access Preference? "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "\n              Do you want to display this event in the public event calendar schedule or\n              make it private so only those with a direct link can access?\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "title" } }, [
      _vm._v("\n            What type of event is this? "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "venueName" } }, [
      _vm._v("\n              Video Streaming Service\n              "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v("Zoom, Facebook Live, Instagram Live, YouTube, etc."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "venueUrl" } }, [
      _vm._v("\n              Webinar or Livestream URL "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "\n                Please test all links to make sure they are functional.\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "meetingPassword" } }, [
      _vm._v("\n              Meeting Password\n              "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "\n                If you have enabled a password for your event, it is critical that you enter it here. We recommend not\n                using a password in order to make it simpler for attendees.\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "venueName" } }, [
      _vm._v("\n              Location Name"),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "venueAddress1" } }, [
      _vm._v("\n              Venue Address"),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "hostEmail" } }, [
      _vm._v("\n            Host Email Contact for Attendees "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "Please enter an e-mail address so that attendees can contact you or an\n              assistant in case there is an issue accessing your event.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-6" }, [
      _c("p", [
        _vm._v(
          "PLEASE NOTE: If your event will be held on multiple days or you have multiple time sessions on the same day,\n        you will need to create a separate event for each different day and/or time."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }